import { posthogTracker } from '@/utils/trackingPostHog';
import { useState, useEffect } from 'react';

export const usePostHogTrackerFeatureFlag = (flag: string) => {
  const [flagVariant, setFlagVariant] = useState<string | boolean | null>(null);

  useEffect(() => {
    posthogTracker.posthog?.onFeatureFlags((_, flagVariants) => {
      setFlagVariant(flagVariants[flag] ?? null);
    });
  }, [flag]);

  return flagVariant;
};

export const useFeatureFlagsSearchTerms = (searchTerms: string) => {
  const featureFlagValue = usePostHogTrackerFeatureFlag('sorting_filter');

  const okSearchTermsFeatureFlags = [
    'visita-medico-sportiva-non-agonistica',
    'visita-dermatologica',
    'ecografia-addome-completo',
    'lavaggio-auricolare',
    'visita-ginecologica',
    'ecografia-mammaria-bilaterale',
    'radiografia-torace-rx',
  ];

  return okSearchTermsFeatureFlags.some(term => term === searchTerms) ? featureFlagValue : 'control';
};
